var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModelEvolution(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/clock"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 1.75C5.89421 1.75 1.75 5.89421 1.75 11C1.75 16.1058 5.89421 20.25 11 20.25C16.1058 20.25 20.25 16.1058 20.25 11C20.25 5.89421 16.1058 1.75 11 1.75ZM0.25 11C0.25 5.06579 5.06579 0.25 11 0.25C16.9342 0.25 21.75 5.06579 21.75 11C21.75 16.9342 16.9342 21.75 11 21.75C5.06579 21.75 0.25 16.9342 0.25 11Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6299 5.76C11.0441 5.76 11.3799 6.09579 11.3799 6.51V10.61C11.3799 10.7635 11.4385 10.9861 11.5689 11.2147C11.6993 11.4434 11.8609 11.6069 11.9922 11.6848L11.9942 11.686L11.9942 11.686L15.0942 13.536C15.4499 13.7482 15.5662 14.2087 15.3539 14.5643C15.1417 14.92 14.6812 15.0363 14.3255 14.824L11.2275 12.9752C11.2272 12.975 11.2268 12.9748 11.2265 12.9746C10.8183 12.7324 10.4903 12.3513 10.2659 11.9578C10.0412 11.5639 9.87988 11.0865 9.87988 10.61V6.51C9.87988 6.09579 10.2157 5.76 10.6299 5.76Z",
    fill: "#3C3C3B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelEvolution);
export default __webpack_public_path__ + "static/media/modelEvolution.de55f5c45b6c7e9bfde770af41e916c3.svg";
export { ForwardRef as ReactComponent };